/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/member-search';
 */
export const layoutConfig = {
    inputConfig: {
        
        //searchPattern: /^[a-z0-9\s@.]+$/i
    },
    styles: {
        borderlessSearch: true,
        inlineTableView: true
    },
    dimensions: {
        maxHeight: 260,
    },
    filterFlyoutWidths: {
        mfiNumber: 160
    },
    columnWidth: {
        firstName: 90,
        lastName: 90,
        dob: 80,
        memberId: 100,
        mfiNumber: 100,
        relationship: 112,
        phoneNumber: 100,
        email: 140,
        stateAndZip: 100,
        carrier: 100,
        group: 100,
        eligibilityStatus: 100,
        
        // special columns
        _groupActions: 70, // group actions column
    },
    actionIcons: {
        initiateCall: 'phone',
    },
};
